document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(min-width: 1000px)').matches) return;

  const updateOneMenu = (menu) => {
    const inner = menu.querySelector('.mega-menu__inner');
    if (!inner) return;

    let btn = inner.querySelector('.cm-mega-toggle');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cm-mega-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Show more';
      inner.appendChild(btn);

      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const expanded = menu.classList.toggle('cm-mega-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? 'Show less' : 'Show more';

        if (!expanded) inner.scrollTop = 0;
      });

      menu.addEventListener('mouseleave', () => {
        if (menu.classList.contains('cm-mega-expanded')) {
          menu.classList.remove('cm-mega-expanded');
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = 'Show more';
          inner.scrollTop = 0;
        }
      });
    }

    // Zjisti overflow podle reálného rozdílu scrollHeight vs clientHeight
    const checkOverflow = () => {
      const over = inner.scrollHeight > inner.clientHeight + 10;

      if (over) {
        menu.setAttribute('data-cm-overflow', 'true');
      } else {
        menu.removeAttribute('data-cm-overflow');
        menu.classList.remove('cm-mega-expanded');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Show more';
        inner.scrollTop = 0;
      }
    };

    // menu se často "dopočítá" až po zobrazení - tak kontrola vícekrát
    requestAnimationFrame(checkOverflow);
    setTimeout(checkOverflow, 60);
    setTimeout(checkOverflow, 160);

    menu.addEventListener('mouseenter', checkOverflow);
    menu.addEventListener('focusin', checkOverflow);

    window.addEventListener('resize', () => {
      if (menu.offsetParent !== null) checkOverflow();
    });
  };

  document.querySelectorAll('.mega-menu').forEach(updateOneMenu);
});
